import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form, InputGroup, Button } from "react-bootstrap";
import "./ProductStatusChange.css";
import { postData } from "../../../../utils/api";
import ModalSave from "../../ModalSave";

const ProductStatusChange = ({
  show,
  onHide,
  setErr,
  showData,
  getAllProductData,
  id,
}) => {
  const [formData, setFormData] = useState({
    inhand_quantity: "",
    applied_quantity: "",
    return_quantity: "",
  });

  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    let newErrors = {};

    // if (!formData.inhand_quantity) {
    //   newErrors.inhand_quantity = "In Hand Quantity is required";
    // }

    if (!formData.applied_quantity) {
      newErrors.applied_quantity = "Applied Quantity is required";
    }

    if (!formData.return_quantity) {
      newErrors.return_quantity = "Return Quantity is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    const payload = {
      // inhand_quantity: formData.inhand_quantity,
      applied_quantity: formData.applied_quantity,
      return_quantity: formData.return_quantity,
    };

    try {
      const response = await postData(
        `/complaint-management/complaints/change-product-status/${showData?.id}`,
        payload
      );

      setShowModal({
        code: response.code,
        message: response.message,
      });

      // ✅ RESET FORM FIELDS
      setFormData({
        inhand_quantity: "",
        applied_quantity: "",
        return_quantity: "",
      });

      setErrors({});

      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        onHide();
        getAllProductData(id);
      }, 1000);
    } catch (error) {
      setErr?.("Something went wrong");
    }
  };

  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Change Assign Quantity</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <p className="product_name">
            <b>Product Name:</b> {""} {showData?.product?.name}
          </p>

          <p className="product_name">
            <b>Quantity Issue:</b> {""} {showData?.quantity}
          </p>

          {/* In Hand Quantity */}
          {/* <Form.Group className="mb-3 d-flex align-items-center inhand_form_holder">
            <Form.Label>In Hand Quantity :</Form.Label>
            <InputGroup>
              <Form.Control
                type="number"
                name="inhand_quantity"
                value={formData.inhand_quantity}
                onChange={handleChange}
                isInvalid={!!errors.inhand_quantity}
              />
              <Form.Control.Feedback type="invalid">
                {errors.inhand_quantity}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group> */}

          {/* Applied Quantity */}
          <Form.Group className="mb-3  d-flex align-items-center inhand_form_holder">
            <Form.Label>Applied Quantity :</Form.Label>
            <InputGroup>
              <Form.Control
                type="number"
                name="applied_quantity"
                value={formData.applied_quantity}
                onChange={handleChange}
                isInvalid={!!errors.applied_quantity}
              />
              <Form.Control.Feedback type="invalid">
                {errors.applied_quantity}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          {/* Return Quantity */}
          <Form.Group className="mb-3 d-flex align-items-center inhand_form_holder">
            <Form.Label>Return Quantity :</Form.Label>
            <InputGroup>
              <Form.Control
                type="number"
                name="return_quantity"
                value={formData.return_quantity}
                onChange={handleChange}
                isInvalid={!!errors.return_quantity}
              />
              <Form.Control.Feedback type="invalid">
                {errors.return_quantity}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          <div className="text-end">
            <Button variant="secondary" className="me-2" onClick={onHide}>
              Cancel
            </Button>
            <Button variant="success" type="submit">
              Update
            </Button>
          </div>
        </Form>
      </Modal.Body>

      <ModalSave
        message={showModal.message}
        showErrorModal={!!showModal.code}
      />
    </Modal>
  );
};

export default ProductStatusChange;
